import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { TEMP_PASSWORD_REQUIREMENT_ITEMS } from '../org-user.util';

@Component({
  selector: 'app-add-org-user-dialog',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './add-org-user-dialog.component.html',
  styleUrl: './add-org-user-dialog.component.scss',
})
export class AddOrgUserDialogComponent {
  #dialogRef = inject(MatDialogRef<AddOrgUserDialogComponent>);

  hidePassword = true;
  passwordRequirementItems = TEMP_PASSWORD_REQUIREMENT_ITEMS;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    temporaryPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    name: new FormControl('', []),
  });

  get email() {
    return this.form.controls.email;
  }

  get temporaryPassword() {
    return this.form.controls.temporaryPassword;
  }

  getEmailErrorMessage(): string {
    if (this.email.hasError('required')) {
      return 'You must enter an email address';
    }
    if (this.email.hasError('email')) {
      return 'You must enter a valid email address';
    }
    return 'You must enter a valid email address';
  }

  getPasswordErrorMessage(): string {
    if (this.temporaryPassword.hasError('required')) {
      return 'You must enter a temporary password';
    }
    if (this.temporaryPassword.hasError('minlength')) {
      return 'Temporary password must be at least 8 characters';
    }
    return 'You must enter a valid temporary password';
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    const name = this.form.controls.name.value?.trim();
    this.#dialogRef.close({
      email: this.form.controls.email.value!.trim(),
      temporaryPassword: this.form.controls.temporaryPassword.value!,
      ...(name ? { name } : {}),
    });
  }
}
